<template>
    <div v-if="!loading">
        <b-row v-if="isProduction">
            <b-col>
                <b-alert
                    show
                    variant="danger"
                >
                    {{ $t('settings.externalServiceAlert') }}
                </b-alert>
            </b-col>
        </b-row>
        <b-row
            v-for="item in services"
            :key="item.serviceId"
            class="py-2 border-bottom"
        >
            <b-col cols="10">
                {{ item.serviceName }}
            </b-col>
            <b-col
                cols="2"
                class="text-right"
            >
                <b-form-checkbox
                    v-if="!item.loading"
                    switch
                    size="lg"
                    :checked="item.isActive"
                    @change="check(item)"
                />
                <b-spinner
                    v-else
                    small
                    class="mr-3 mt-1"
                />
            </b-col>
        </b-row>
    </div>
    <div
        v-else
        class="text-center"
    >
        <b-spinner />
    </div>
</template>

<script>
import params from '@/config/params';
import getModalConfirmConfig from '@/config/modalConfirm';

export default {
    name: 'ExternalServiceList',

    data() {
        return {
            loading: false,
            services: [],
            params,
        };
    },

    computed: {
        isProduction: () => {
            return params.env === 'prod';
        },
    },

    methods: {
        load: async function() {
            this.loading = true;
            const { data } = await this.axios.get('services');
            this.services = data.map((item) => {
                return {
                    ...item,
                    loading: false,
                };
            });
            this.loading = false;
        },

        check: async function(service) {
            service.loading = true;
            const modalConfirmConfig = getModalConfirmConfig();
            modalConfirmConfig.okTitle = this.$t('main.external.ok');
            modalConfirmConfig.cancelTitle = this.$t('main.external.cancel');
            const value = await this.$bvModal.msgBoxConfirm(
                this.$t('main.external.text'),
                modalConfirmConfig,
            );

            if (value) {
                service.isActive = await this.save(service);
            }

            service.loading = false;
        },

        save: async function(service) {
            const isActive = !service.isActive;
            await this.axios.post(
                'services',
                {
                    service: service.serviceId,
                    enable: isActive,
                },
            );

            return isActive;
        },
    },

    mounted() {
        this.load();
    },
};
</script>